import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Search, Filter } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Insights = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const categories = ['All', 'Tax Advisory', 'Strategic Advisory', 'Capital', 'Global Markets', 'Policy'];
  const posts = [{
    title: 'Strategic Tax Planning for Cross-Border Business',
    category: 'Tax Advisory',
    date: 'July 12, 2024',
    author: 'Managing Partner',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/beb12f25-1672-451d-b509-1a1ff4f650cc.jpg',
    featured: true,
    excerpt: 'Navigating the complexities of international tax laws requires a proactive approach and deep technical mastery. Discover how to optimize your global tax position.'
  }, {
    title: 'Investment Strategies in Emerging Markets',
    category: 'Capital',
    date: 'July 10, 2024',
    author: 'Managing Partner',
    img: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?auto=format&fit=crop&q=80',
    featured: false
  }, {
    title: 'Navigating International Expansion Complexity',
    category: 'Advisory',
    date: 'July 08, 2024',
    author: 'Managing Partner',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/9edda6d8-d096-4dec-8406-49d89899a16e.jpg',
    featured: false
  }, {
    title: 'The Future of Sustainable Agriculture in Africa',
    category: 'Global Markets',
    date: 'July 05, 2024',
    author: 'Managing Partner',
    img: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&q=80',
    featured: false
  }, {
    title: 'Governance and Policy: Shaping the Future',
    category: 'Policy',
    date: 'July 01, 2024',
    author: 'Managing Partner',
    img: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&q=80',
    featured: false
  }, {
    title: 'Wealth Preservation for High-Net-Worth Individuals',
    category: 'Tax Advisory',
    date: 'June 28, 2024',
    author: 'Managing Partner',
    img: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&q=80',
    featured: false
  }];
  const filteredPosts = posts.filter(post => {
    const matchesCategory = activeCategory === 'All' || post.category === activeCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.excerpt && post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  return <main className="pt-24 bg-brand-warm-white min-h-screen" data-id="element-404">
      {/* Header */}
      <section className="bg-brand-navy py-24 text-white relative overflow-hidden" data-id="element-405">
        <div className="absolute inset-0 opacity-10" data-id="element-406">
          <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/patterns/generated-images/117d0dd0-f932-4c9a-8c93-2d7bc64949ec.jpg')] bg-cover bg-center" data-id="element-407" />
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-408">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-6 block" data-id="element-409">
            Thought Leadership
          </span>
          <h1 className="text-5xl md:text-7xl font-display mb-8" data-id="element-410">
            Featured <br data-id="element-411" />
            <span className="italic" data-id="element-412">Insights</span>.
          </h1>
          <p className="text-xl text-white/70 max-w-2xl leading-relaxed" data-id="element-413">
            Strategic analysis and expert perspectives on finance, advisory, and
            global commerce.
          </p>
        </motion.div>
      </section>

      {/* Filter Bar */}
      <section className="sticky top-20 z-30 bg-white/80 backdrop-blur-md border-b border-brand-navy/5 py-4" data-id="element-414">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-415">
          <div className="flex gap-6 overflow-x-auto no-scrollbar w-full md:w-auto pb-2 md:pb-0" data-id="element-416">
            {categories.map((cat, i) => <button key={i} onClick={() => setActiveCategory(cat)} className={`text-xs font-bold uppercase tracking-widest whitespace-nowrap transition-colors ${activeCategory === cat ? 'text-brand-gold' : 'text-brand-charcoal/40 hover:text-brand-navy'}`} data-id="element-417">
                {cat}
              </button>)}
          </div>
          <div className="relative w-full md:w-64" data-id="element-418">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-brand-charcoal/30" size={16} data-id="element-419" />
            <input type="text" placeholder="Search Insights..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-brand-warm-white border-none py-3 pl-12 pr-4 rounded-full text-sm outline-none focus:ring-1 focus:ring-brand-gold" data-id="element-420" />
          </div>
        </div>
      </section>

      {/* Insights Grid */}
      <section className="py-24" data-id="element-421">
        <div className="max-w-7xl mx-auto px-6" data-id="element-422">
          <AnimatePresence mode="popLayout" data-id="element-423">
            {filteredPosts.length > 0 ? <motion.div layout className="grid lg:grid-cols-3 gap-12" data-id="element-424">
                {filteredPosts.map((post, i) => <motion.div key={post.title} layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.4
            }} className={`${post.featured ? 'lg:col-span-3 mb-12' : ''} group`} data-id="element-425">
                    <Link to={`/insights/${post.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '')}`} state={{
                post
              }} className={`${post.featured ? 'grid lg:grid-cols-2 gap-12 items-center' : 'flex flex-col h-full'} block`} data-id="element-426">
                      <div className={`relative overflow-hidden rounded-3xl ${post.featured ? 'aspect-[16/9]' : 'aspect-[4/3] mb-8'}`} data-id="element-427">
                        <img src={post.img} alt={post.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-428" />
                        <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-md px-4 py-1 text-[10px] font-bold tracking-widest uppercase text-brand-navy" data-id="element-429">
                          {post.category}
                        </div>
                      </div>
                      <div className={post.featured ? 'py-8' : 'flex flex-col flex-grow'} data-id="element-430">
                        <div className="text-brand-charcoal/40 text-xs uppercase tracking-widest mb-4 flex items-center gap-4" data-id="element-431">
                          <span data-id="element-432">{post.date}</span>
                          <span className="w-1 h-1 rounded-full bg-brand-gold" data-id="element-433" />
                          <span data-id="element-434">{post.author}</span>
                        </div>
                        <h3 className={`${post.featured ? 'text-4xl md:text-5xl' : 'text-2xl'} font-display text-brand-navy group-hover:text-brand-gold transition-colors leading-tight mb-6`} data-id="element-435">
                          {post.title}
                        </h3>
                        {post.featured && <p className="text-brand-charcoal/60 text-lg leading-relaxed mb-8 max-w-xl" data-id="element-436">
                            {post.excerpt}
                          </p>}
                        <div className="mt-auto inline-flex items-center gap-3 text-brand-navy font-bold tracking-widest uppercase text-xs border-b-2 border-brand-gold pb-2 group-hover:gap-5 transition-all self-start" data-id="element-437">
                          Read Article{' '}
                          <ArrowRight size={16} className="text-brand-gold" data-id="element-438" />
                        </div>
                      </div>
                    </Link>
                  </motion.div>)}
              </motion.div> : <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className="text-center py-20" data-id="element-439">
                <h3 className="text-2xl font-display text-brand-navy mb-4" data-id="element-440">
                  No Insights Found
                </h3>
                <p className="text-brand-charcoal/60" data-id="element-441">
                  We couldn't find any articles matching your current filters.
                </p>
                <button onClick={() => {
              setActiveCategory('All');
              setSearchQuery('');
            }} className="mt-8 text-brand-gold font-bold tracking-widest uppercase text-xs border-b border-brand-gold/30 pb-1 hover:border-brand-gold transition-all" data-id="element-442">
                  Clear Filters
                </button>
              </motion.div>}
          </AnimatePresence>

          {/* Pagination */}
          <div className="mt-24 flex justify-center gap-4" data-id="element-443">
            <button className="w-12 h-12 rounded-full border border-brand-navy/10 flex items-center justify-center text-brand-navy font-bold hover:bg-brand-navy hover:text-white transition-all" data-id="element-444">
              1
            </button>
            <button className="w-12 h-12 rounded-full border border-brand-navy/10 flex items-center justify-center text-brand-charcoal/40 font-bold hover:border-brand-navy hover:text-brand-navy transition-all" data-id="element-445">
              2
            </button>
            <button className="w-12 h-12 rounded-full border border-brand-navy/10 flex items-center justify-center text-brand-charcoal/40 font-bold hover:border-brand-navy hover:text-brand-navy transition-all" data-id="element-446">
              3
            </button>
          </div>
        </div>
      </section>
    </main>;
};